import { FsMatchTrack } from "db/model/match/Track/FsMatchTrack";
import { Roster } from "model/Roster/Roster";
import { nonUndefined } from "Utility";
import { mapRoundsRounds } from "./FsRoundsRound";
import { RoundsTrack } from "model/Match/Set/Rounds/Track/RoundsTrack";
import { PointsDistribution } from "model/Match/Set/PointsDistribution";
import { Scores } from "model/Scores";
import { mapMatchTrackBase } from "../../Track/FsMatchTrack";
import { mapTrackRounds } from "../../Track/FsTrackRound";
import { RosterScope } from "model/Roster/RosterScope";

export const mapRoundsTracks = (
  fsModels: FsMatchTrack[],
  rosters: Roster[],
  rosterScope: RosterScope,
  runningScores: Scores,
  pointsDist: PointsDistribution,
  roundsPerTrack: number
) => {
  return nonUndefined(
    fsModels.map((t) =>
      mapRoundsTrack(
        t,
        rosters,
        rosterScope,
        runningScores,
        pointsDist,
        roundsPerTrack
      )
    )
  );
};

export const mapRoundsTrack = (
  fsModel: FsMatchTrack,
  rosters: Roster[],
  rosterScope: RosterScope,
  runningScores: Scores,
  pointsDist: PointsDistribution,
  roundsPerTrack: number
): RoundsTrack | undefined => {
  const baseRounds = mapTrackRounds(nonUndefined(fsModel.rounds ?? []));
  const rounds = mapRoundsRounds(
    baseRounds,
    rosters,
    rosterScope,
    runningScores,
    pointsDist
  );

  return {
    ...mapMatchTrackBase(fsModel),
    isComplete: !!fsModel.overrideComplete
      ? true
      : rounds.length >= roundsPerTrack,
    rounds,
  };
};
